import React from "react";
import Modal from "components/modal";
import { ReactComponent as Closy } from "assets/svgs/closy.svg";
import { ReactComponent as Square } from "assets/svgs/square.svg";
import Image from "components/image";
import RichText from "components/rich-text";
import useToggle from "hooks/useToggle";

const BoxWithModal = ({ data }) => {
	const [isOpen, toggle] = useToggle();
	const { modal = null, text, triggerText, image = null } = data ?? {};

	const BoxModal = () => (
		<Modal
			className="md:w-[520px]"
			hideHeader={true}
			isOpen={isOpen} close={toggle}>
			<div className="flex justify-center rounded-t px-4 md:px-14 py-5 sticky top-0 bg-white z-10">
				{modal?.icon && <Image width={100} image={modal?.icon} />}
				<button className="absolute top-3 right-5 p-2 ml-auto" onClick={toggle}>
					<Closy />
				</button>
			</div>
			<div className="box-border flex items-stretch flex-col pt-2 pb-5 px-8 md:px-14">
				<div className="flex items-stretch flex-col">
					<RichText value={modal?.content} />
					{modal?.list &&
						<div className="flex flex-col flex-shrink-0 mt-3 relative">{
							modal.list.map((listItem, i) => (
								<div className="flex flex-shrink-0 relative" key={listItem._key}>
									<div className="flex flex-shrink-0 ">
										{i + 1 !== modal.list.length &&
											<div className="flex flex-col absolute w-0.5 bg-[#E3E5E9] h-full top-4 left-1" />}
										<div className="flex flex-col z-0 pt-4 pr-4">
											<Square />
										</div>
									</div>
									<div className="flex flex-col pt-4">
										<div className="flex flex-col pb-4">
											<p className="pb-1 pt-px -mt-1 -mb-2.5">{listItem.text}</p>
										</div>
										<div className="flex flex-col pb-4" />
									</div>
									{listItem.image && <Image className="w-14 h-8 ml-3 mt-1" image={listItem.image} />}
								</div>
							))}
						</div>}
				</div>

			</div>
			{modal?.button &&
				<div className="p-4">
					<button className="btn-primary w-full normal-case" onClick={toggle}>
						{modal.button}
					</button>
				</div>}

		</Modal>
	);

	return (
		text &&
		<div className="flex flex-wrap gap-3 items-center text-left bg-[#f0eeeb] px-3.5 py-2 ">
			<p>{text}</p>
			<button
				onClick={toggle} className="text-[#17120f] underline whitespace-nowrap border-none text-base">
				{triggerText}
			</button>
			{image && <Image className="w-16 h-8" image={image} />}
			{modal && <BoxModal data={modal} />
			}
		</div>
	);
};

export default BoxWithModal;